<template>
	<div
		class="customer-assignation"
		:class="[
			isFlyout
				? 'customer-assignation--manage-customers'
				: 'customer-assignation--pre-assign-customers'
		]"
	>
		<div class="customer-assignation__search">
			<Search
				variant="toggle-icons"
				v-model="search"
				placeholder="Search Clients"
			/>
		</div>
		<ul class="customer-assignation__list">
			<li
				:class="[
					isFlyout
						? 'customer-assignation__list-item' +
						  [customer.modelValue ? ' is-checked' : '']
						: 'customer-assignation__list-item'
				]"
				v-for="customer in customers"
				:key="customer.value"
			>
				<CustomerAssignationItem
					:customer="customer"
					:isFlyout="isFlyout"
					@change="updateCustomer"
				/>
			</li>
		</ul>
	</div>
</template>

<script>
import Search from '@/components/forms/search/search';
import CustomerOptionsMixin from '@/mixins/customers/customer-options';
import CustomerAssignationItem from '@/sections/forms/views/customer-assignation-item.vue';
import { CUSTOMER_OPTIONS } from '@/sections/options/options-mutation-type';
import { filterAndSortArray } from '@/utils/function';

export default {
	name: 'CustomerAssignation',
	mixins: [CustomerOptionsMixin],
	model: {
		prop: 'preassignCustomers',
		event: 'update'
	},
	components: {
		Search,
		CustomerAssignationItem
	},
	props: {
		preassignCustomers: {
			type: Array,
			default: () => []
		},
		isFlyout: {
			type: Boolean,
			default: false
		},
		assignedCustomersIds: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			search: '',
			customers: []
		};
	},
	computed: {
		activeCustomers() {
			let { items } = { ...this[CUSTOMER_OPTIONS] };
			let customers = [];

			if (items && items.length) {
				customers = filterAndSortArray(items, {
					active: true
				}).map(c => {
					return Object.assign({}, c, {
						modelValue: '',
						enabled: false
					});
				});
			}

			return customers;
		}
	},
	methods: {
		updateCustomer(obj) {
			const hasValue = !!obj.modelValue;
			let assignedList = [...this.preassignCustomers] || [];

			const idx = assignedList.findIndex(x => x.customerId === obj.value);

			if (idx > -1) {
				if (hasValue) {
					Object.assign(assignedList[idx], {
						enabled: obj.enabled
					});
				} else {
					assignedList.splice(idx, 1);
				}
			} else if (hasValue) {
				assignedList.push({
					customerId: obj.value,
					enabled: obj.enabled
				});
			}

			this.$emit('update', assignedList);
		},
		getCustomers() {
			let customers = [...this.activeCustomers];
			let assignedList = [...this.preassignCustomers] || [];

			if (assignedList.length) {
				assignedList.forEach(p => {
					var idx = customers.findIndex(
						x => x.value === p.customerId
					);

					if (idx > -1) {
						Object.assign(customers[idx], {
							modelValue: p.customerId,
							enabled: p.enabled
						});
					}
				});
			}

			if (this.search) {
				const search = this.search.toLowerCase();
				customers = customers.filter(
					x =>
						(x.text && x.text.toLowerCase().includes(search)) ||
						(x.description &&
							x.description.toLowerCase().includes(search))
				);
			}

			//filters out all which is on top of flyout
			if (this.isFlyout && this.assignedCustomersIds.length) {
				customers = customers.filter(
					x => !this.assignedCustomersIds.includes(x.value)
				);
			}

			// if (this.customerName) {
			// 	var idx = customers.findIndex(x => x.value === this.customerName);

			// 	if (idx > -1) {
			// 		Object.assign(customers[idx], {
			// 			modelValue: this.customerName
			// 		});
			// 	}
			// }

			this.customers = customers;
		}
	},
	watch: {
		preassignCustomers: {
			deep: true,
			immediate: true,
			handler() {
				this.getCustomers();
			}
		},
		search: {
			handler() {
				this.getCustomers();
			}
		}
	}
};
</script>

<style lang="scss">
/**
  * Customer Assignation Search and List
  * Used in Manage Customers Flyout and
  * Pre-assign Customers Accordion section on Form Designer
  * Can use SCSS variables = TRUE
*/

.customer-assignation {
	&__search {
		@include mq($from: md) {
			max-width: 380px;
		}
	}

	&__list {
		@include scrollbar;

		&-item {
			&:not(:first-child) {
				margin-top: $gutter-lg;
			}
		}
	}
}

/*------------------------------------*\
  #PRE-ASSIGN CUSTOMERS
  Only visible on the Impact and Laser Form Designer prior to first Publish
\*------------------------------------*/

.customer-assignation--pre-assign-customers {
	.customer-assignation__search {
		margin: $gutter-xl 0;
	}

	.customer-assignation__list {
		max-height: 520px;
		overflow: auto;
	}
}

/*------------------------------------*\
  #MANAGE CUSTOMERS
  Displayed in a flyout component accessible from Global Form Manager Card and Form Designer
\*------------------------------------*/
.customer-assignation--manage-customers {
	flex-wrap: nowrap;
	display: flex;
	flex-direction: column;
	overflow: hidden;
	height: 100%;
	flex-grow: 1;
	flex-shrink: 1;
	min-height: 100px;
	overflow: hidden;
	.customer-assignation__search {
		margin-bottom: $gutter-lg;
	}

	.customer-assignation__list {
		padding-inline-start: 0;
		height: calc(100% - 48px);
		overflow: auto;

		&-item {
			&.is-checked {
				padding-bottom: $padding-md;
				&:not(:last-child) {
					border-bottom: 1px solid $neutral-3;
				}
			}
		}
	}
}
</style>
